<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="aiKnowledgeBase.title"
              [isError]="$any(errors?.title)"></crm-input-text>
            <small
              *ngIf="errors?.title"
              class="p-error">
              {{ errors.title | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Содержимое</label>
            <crm-editor
              [(value)]="aiKnowledgeBase.content"
              height="300px"></crm-editor>
            <small
              *ngIf="errors?.content"
              class="p-error">
              {{ errors.content | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип</label>
            <crm-single-select
              [options]="categories"
              [(selectedItem)]="aiKnowledgeBase.category"
              [class]="errors?.category ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.category ? 'ng-invalid ng-dirty' : ''"
              [filter]="false"
              [isTemplateCombined]="true"
              optionValue="name"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-category="item">
                {{ category.value | knowledgeBaseCategoryName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.category"
              class="p-error">
              {{ errors.category | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Хэш</label>
            <crm-input-text
              [(value)]="aiKnowledgeBase.contentHash"
              [isError]="$any(errors?.contentHash)"></crm-input-text>
            <small
              *ngIf="errors?.contentHash"
              class="p-error">
              {{ errors.contentHash | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Файл</label>
            <p
              *ngIf="aiKnowledgeBase?.file?.name"
              class="mb-3">
              {{ aiKnowledgeBase.file.name }}
            </p>
            <crm-file-uploader
              label="Загрузить"
              (filesUploaded)="setFile($event)"></crm-file-uploader>
            <small
              *ngIf="errors?.file"
              class="p-error">
              {{ errors.file | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveKnowledgeBase()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !aiKnowledgeBase['deleted']"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteKnowledgeBase()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && aiKnowledgeBase['deleted']"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreKnowledgeBase()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
